import React from 'react';
import { pdf } from '@react-pdf/renderer';
import InvoicePDF from '../pdf/InvoicePDF';
import { getOrganizationCurrency, getOrganizationTaxSettings } from './currencyUtils';

export async function createInvoiceBlob(invoice) {
  if (!invoice) throw new Error('Invoice data is required for PDF');
  const [currency, taxSettings] = await Promise.all([
    getOrganizationCurrency(),
    getOrganizationTaxSettings()
  ]);
  const organization = invoice?.organization || null;
  const clinic = invoice?.clinic || null;
  const instance = pdf(
    <InvoicePDF
      invoice={invoice}
      organization={organization}
      clinic={clinic}
      currency={currency}
      taxRate={taxSettings.taxRate}
      taxLabel={taxSettings.taxLabel}
      taxInclusive={taxSettings.taxInclusive}
    />
  );
  const blob = await instance.toBlob();
  return blob;
}

export async function downloadInvoicePDF(invoice) {
  try {
    const blob = await createInvoiceBlob(invoice);
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${invoice.invoiceNumber || 'Invoice'}_${new Date(invoice.invoiceDate).toLocaleDateString('en-IN').replace(/\s/g,'_')}.pdf`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  } catch (err) {
    console.error('Invoice PDF download error:', err);
    throw new Error(err?.message || 'Failed to generate invoice PDF');
  }
}

export async function openInvoicePDF(invoice) {
  try {
    const blob = await createInvoiceBlob(invoice);
    const url = URL.createObjectURL(blob);
    const w = window.open(url, '_blank');
    if (!w) throw new Error('Popup blocked. Allow popups for this site to print.');
  } catch (err) {
    console.error('Invoice PDF open error:', err);
    throw new Error(err?.message || 'Failed to generate invoice PDF');
  }
}


